import React from 'react'
function BannerInfo() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
    <div className="card-body">
      <h2 className="card-title">GO Explotación de Datos – DG Gobernanza de Datos</h2>
      <p className="card-text">
      La GO Explotación de Datos es un área de Gobierno que trabaja en la gestión, producción
y disponibilización de la información geográfica.<br/><br/>
Esta labor no es nueva, sino que cuenta con una sólida historia, ya que desde hace más
de dos décadas el Gobierno de la Ciudad de Buenos Aires tiene un manejo sistemático de
la información geoespacial. A través de los años, la ex USIG (hoy GOED) se convirtió en un
área referente en la gestión de este tipo de datos, mediante una mirada transversal que
busca el trabajo colaborativo con todas las áreas de gobierno, publicando los datos
mediante visores de mapas (Mapa Interactivo de la Ciudad) como además la
disponibilización de datasets en BA Data. Esta iniciativa interesó en distintas áreas de
gobierno las cuales, avanzaron en la generación y publicación de sus propios datos.
      </p>
    </div>
  </div>
</div>

  )
}

export default BannerInfo